module.exports = __webpack_public_path__ + "img/BTC.6717ade2.svg";